import {
  createBlock,
  mergeBlock,
  NodeUtils,
  t,
} from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  Element,
  ElementDefinition,
  StandardTable2Element,
} from "@easy-email-pro-core/typings";
import React from "react";
import { BlockRenderer, Table } from "@easy-email-pro-core/components";

const defaultData: ElementDefinition<StandardTable2Element>["defaultData"] = {
  attributes: {
    align: "left",
    "text-align": "center",
    border: "none",
    cellpadding: "0",
    cellspacing: "0",
    color: "#000000",
    "font-family": "Ubuntu, Helvetica, Arial, sans-serif",
    "font-size": "13px",
    "line-height": "22px",
    padding: "10px 25px",
    "padding-top": "10px",
    "padding-right": "25px",
    "padding-bottom": "10px",
    "padding-left": "25px",
    "table-layout": "auto",
    width: "100%",

    "border-color": "#000000",
    "border-style": "solid",
    "border-width": "1px",
    "border-enabled": true,
    "cell-padding-top": "10px",
    "cell-padding-bottom": "10px",
    "cell-padding-right": "10px",
    "cell-padding-left": "10px",
  },
  data: {},
};

export const StandardTable2 = createBlock<StandardTable2Element>({
  get name() {
    return t("Table");
  },
  void: false,
  defaultData,
  type: StandardType.STANDARD_TABLE2,
  create: (payload) => {
    const defaultData: StandardTable2Element = {
      type: StandardType.STANDARD_TABLE2,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.TABLE,
  render(params) {
    const { node } = params;

    const {
      "border-enabled": borderEnabled = true,
      "border-width": borderWidth,
      "border-style": borderStyle,
      "border-color": borderColor,
      "cell-padding-top": cellPaddingTop,
      "cell-padding-bottom": cellPaddingBottom,
      "cell-padding-left": cellPaddingLeft,
      "cell-padding-right": cellPaddingRight,
      ...attributes
    } = node.attributes;

    const top = cellPaddingTop || defaultData.attributes["cell-padding-top"];
    const right =
      cellPaddingRight || defaultData.attributes["cell-padding-right"];
    const bottom =
      cellPaddingBottom || defaultData.attributes["cell-padding-bottom"];
    const left = cellPaddingLeft || defaultData.attributes["cell-padding-left"];
    const cellPadding = `${top} ${right} ${bottom} ${left}`;

    return (
      <Table {...attributes} cellpadding={cellPadding}>
        <>
          <tbody>
            {node.children.map((item, index) => {
              if (NodeUtils.isTextNode(item)) {
                return <React.Fragment key={index}></React.Fragment>;
              }

              return (
                <BlockRenderer
                  key={index}
                  node={
                    {
                      ...item,
                      attributes: {
                        "border-color": borderColor,
                        "border-style": borderStyle,
                        "border-width": borderWidth,
                        "border-enabled": borderEnabled,
                        "text-align": node.attributes["text-align"],
                        ...item.attributes,
                      },
                    } as Element
                  }
                />
              );
            })}
          </tbody>
        </>
      </Table>
    );
  },
});
